<template>
    <div class="w-full flex flex-column gap-5
        px-0 xl:px-3 lg:px-3 md:px-3">
        <WalletWidget v-if="wallet" @refresh="refresh"
            :title="getWalletNameByType(wallet.ext_type, lang)"
            :balance="wallet.balance" 
            :currency="currency" 
            :wallets="wallets"
            :wallet_id="wallet.id" 
            :wallet_type="wallet.ext_type"
            :deposit_wallet_id="depositWalletId"
            :loading="loading" 
            :btnTopup="wallet.ext_type !== 'partner' || Boolean(depositWalletId)"
            :btnWithdraw="isUserInGroup('merchant', 'manager', 'admin', 'tester')"
            />
        
        <div class="w-full flex gap-5 mb-3
            px-3 xl:px-0 lg:px-0 md:px-0
            flex-column xl:flex-row lg:flex-row md:flex-row">

            <!--Accounts-->
            <div class="w-full flex flex-column xl:w-4 lg:w-4">
                <div class="w-full flex flex-row mb-3">
                    <div class="flex flex-1 align-items-center">
                        <span class="text-xl font-medium text-900 h-2rem">{{ content[lang].accounts }}</span>
                    </div>
                    <div class="flex">
                        <!-- <Button label="Все акк." @click="toAccounts(wallet_id)" size="small" severity="secondary"
                            class="flex surface-0 text-xs" icon="pi pi-arrow-right" iconPos="right" rounded /> -->
                    </div>
                </div>
                <div class="w-full flex">
                    <Accounts v-if="wallet && wallet.account_details && wallet.account_details.length>0"
                        :accounts="wallet.account_details" :loading="loading"/>
                    <Skeleton v-if="loading" height="2rem" class="mb-3" />
                </div>
            </div>

            <!--Transactions-->
            <div class="w-full flex flex-column xl:w-8 lg:w-8">
                <div class="w-full flex flex-row mb-3">
                    <div class="flex flex-1 align-items-center">
                        <span class="text-xl font-medium text-900 h-2rem">{{ content[lang].transactions }}</span>
                    </div>
                    <div class="flex">
                        <Button v-if="!loading && wallet && wallet.transactions && wallet.transactions.length>0"
                            :label="content[lang].transactionsBtn" @click="toTransactions()" size="small" severity="secondary"
                            class="flex surface-0 text-xs" icon="pi pi-arrow-right" iconPos="right" rounded />
                    </div>
                </div>
                <div class="w-full flex">
                    <Transactions v-if="!loading && wallet && wallet.transactions && wallet.transactions.length>=0"
                        :transactions="wallet.transactions" :loading="loading"/>
                    <Skeleton v-if="loading" height="2rem" class="mb-3" /> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import { useRoute } from    'vue-router'
import WalletWidget from    '@/components/personal/wallet/WalletWidget.vue'
import Page         from    '@/components/sides/Page.vue' 
import Accounts         from '@/components/personal/Accounts.vue'
import Transactions     from '@/components/personal/Transactions.vue'
import { mapActions } from  'vuex'

export default {
    data() {
        return {
            wallet: null,
            currency: null,
            // wallets: [],
            header: {
                en: { title: 'Wallet' },
                ru: { title: 'Кошелек' }
            },
            content: {
                ru: { 
                    error: 'Ошибка',
                    notfound: 'Кошелек не найден',

                    topupBtn: 'Пополнить',
                    withdrawBtn: 'Вывести',
                    exchangeBtn: 'Обменять',
                    accounts: 'Счета',
                    transactions: 'Транзакции',
                    transactionsBtn: 'Все транзакции',
                    popupTopupTransfet: 'Перевод с карты',
                    popupTopupTitle: 'Пополнить с карты',
                    popupTopupTopup: 'Пополнить криптовалютой',
                    popupTopupExchange: 'Обменять',
                    popupWithdrawCrypto: 'Вывести криптовалюту',
                    popupTopupBtn: 'Пополнить',
                    popupWithdrawBtn: 'Вывести',
                    notfound: 'Кошелек не найден'
                },
                en: { 
                    error: 'Error' ,
                    notfound: 'Wallet not found',

                    topupBtn: 'Top up',
                    withdrawBtn: 'Withdraw',
                    exchangeBtn: 'Exchange',
                    accounts: 'Accounts',
                    transactions: 'Transactions',
                    transactionsBtn: 'All transactions',
                    popupTopupTransfet: 'Transfer from card',
                    popupTopupTitle: 'Top up from card',
                    popupTopupTopup: 'Top up with cryptocurrency',
                    popupTopupExchange: 'Exchange',
                    popupWithdrawCrypto: 'Withdraw cryptocurrency',
                    popupTopupBtn: 'Top up',
                    popupWithdrawBtn: 'Withdraw',
                    notfound: 'Wallet not found'
                }
            },
            loading: false,
            // type: null,
            depositWalletId: null,
        }
    },
    components: {
        WalletWidget,
        Page,
        Accounts,
        Transactions
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        depositWalletId() { return this.getDepositWalletId(this.$store.getters.StateWallets)},
        wallets() { return this.$store.getters.StateWallets },
        loadingWallets() { return this.$store.getters.StateLoadingWallets },
    },
    watch: {
        wallets: {
            handler(list) {
                if(!list || !Array.isArray(list)) return
                this.wallet = list.find(wallet => wallet.ext_type === this.type)
                this.currency = (this.wallet?.account_details?.[0]?.currency) ? this.wallet.account_details[0].currency : null
            },
            immediate: true
        },
        loadingWallets(newVal) {
           this.loading = newVal
        },
    },
    methods: {
        ...mapActions(['ActionGetWalletByType', 'SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        isUserInGroup (type) { return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)},
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        getDepositWalletId(list) {
            if(!list || !Array.isArray(list)) return null
            if(list && list.length > 0) {
                for (let i = 0; i < list.length; i++) {
                    if(list[i].type == 'deposit') return list[i].id
                }
            } else return null
        },
        getWalletNameByType(type) {
            return this.helper.getWalletNameByType(type, this.lang)
        },
        toTransactions() {
            if(!this.wallet || !this.wallet.ext_type) return
            this.$router.push({ path: `/personal/transactions/${this.wallet.ext_type}/` })
        },
        toAccounts() {
            if(!this.wallet || !this.wallet.type) return
            this.$router.push({ path: `/personal/account/${this.wallet.type}/` })
        },
        async refresh(){
            if(!this.type) return
            this.loading = true
            try { await this.ActionGetWalletByType(this.type).then(res=>res) } 
            catch (error) { console.log(error) }
            this.loading = false
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        const route = useRoute()
        let type = (route.params.type) ? route.params.type : null
        if(type) this.type = type
        else {
            this.type = null
            this.showMess('error', this.content[this.lang].error, this.content[this.lang].notfound)
        }
    },
    async mounted() {
        try {
            this.SetHeaderTitle(this.getWalletNameByType(this.type, this.lang))
            this.SetHeaderBtnLeftFirst({
                type: 'link',
                link: '/personal/wallets/',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                type: 'action',
                action: 'ActionGetAllWallets',
                icon: 'pi pi-sync',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    },
}
</script>